import React from 'react'
import DevelopmentsGrid from '../3'
import { RealEstateDataPageComponentData } from 'types'

interface ExternalProps {
  tag: string
}
type CombinedProps = ExternalProps & RealEstateDataPageComponentData

const GridDevelopment4 = ({
  tag,
  global_data,
  title,
  align,
  paragraph,
  columns,
  excludeTag,
  backgroundColor,
  backgroundHexa,
  titleColor,
  titleHexa,
  darkMode,
  hidden,
  titleElement,
  customFontSize,
}: CombinedProps) => {
  return (
    <DevelopmentsGrid
      tag={tag}
      global_data={global_data}
      title={title}
      align={align}
      hidden={hidden}
      paragraph={paragraph}
      columns={columns}
      excludeTag={excludeTag}
      backgroundColor={backgroundColor}
      backgroundHexa={backgroundHexa}
      titleColor={titleColor}
      titleHexa={titleHexa}
      darkMode={darkMode}
      titleElement={titleElement || 'h2'}
      customFontSize={customFontSize}
    />
  )
}

export default GridDevelopment4
